const MODULES = ["m1", "m2", "m3"];

export const AboutSection = ({ c }) => (
  <section id="about" aria-labelledby="about-title" data-track-section="about" data-nexus-s=".55" data-nexus-dim=".42" className="section">
    <div className="wrap">
      <div className="about-layout">
        <div className="reveal">
          <p className="kicker">{c.kicker}</p>
          <h2 id="about-title" className="section-title">{c.title}</h2>
        </div>
        <div className="reveal">
          <p className="lede" data-testid="about-body">{c.body}</p>
          <ul className="mini-grid">
            {MODULES.map((m, i) => (
              <li key={m} className="mini" data-testid={`about-module-${i + 1}`}>
                <h3 className="mini-label">{c[`${m}_label`]}</h3>
                <p className="mini-claim">{c[`${m}_claim`]}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
